module.exports = __webpack_public_path__ + "img/cert10.bc04adb4.png";